import React from "react";
import { useToggle } from "../../hooks/useToggle";
import { ServiceApprovalDialog } from "./ServiceApprovalDialog";
import { Button } from "@material-ui/core";
import { ApprovalInfo } from "../../generated/nest-graphql";

export type ServiceApprovalButtonProps = {
  jobId: string;
  approvalInfo?: ApprovalInfo | null;
  showCondition?: boolean;
  disabled: boolean;
};

export const ServiceApprovalButton: React.FC<ServiceApprovalButtonProps> = ({
  jobId,
  approvalInfo,
  showCondition = true,
  disabled,
}) => {
  const [dialogOpen, , toggleDialog] = useToggle();

  if (!showCondition) {
    return null;
  }

  return (
    <>
      <Button disabled={disabled} className="w-1/2" variant="contained" color="secondary" onClick={toggleDialog}>
        Service Approval
      </Button>
      <ServiceApprovalDialog open={dialogOpen} onClose={toggleDialog} jobId={jobId} approvalInfo={approvalInfo} />
    </>
  );
};
